import * as React from 'react';
import System from "../../helper/system";
import Constants from 'src/helper/Constants';
import newImg from "src/assets/images/new.png";
import farnell from "src/assets/images/farnell.png";
import element14logo from "src/assets/images/element14-logo.png";
import FadeInOut from '../Global/FadeInOut';

const AdditionalStock = (props) => {
    const { translation: t } = System;
    const { countryCodesForFarnalElement, systemModules: { PLP } } = Constants;

    const countryCode = System.getCountryCode()
    const isEligibleForElement = countryCodesForFarnalElement.includes(countryCode);

    const handleStockPopup = () => {
        System.popup('FarnelElementStockPopup', { isEligibleForElement: isEligibleForElement, erpPartNumber: props.erpPartNumber.ERPPartNumber, countryCode: countryCode });
    };

    const renderStockLink = (stockType, logo) => (
        <a className="d-inline-flex align-items-center text-blue cursor-pointer additional-stock" onClick={handleStockPopup}>
            <div className="d-flex align-items-center">
                <img src={newImg} alt="new stock" />
                <span className="text-ports ms-1">
                    {props.isFrom !== PLP && t('view')} {t(stockType)}
                </span>
            </div>
            {logo &&
                <div className='text-right ms-auto'>
                    <img src={logo} className='img-fluid cursor-pointer' />
                </div>
            }
        </a>
    );

    return (
        <>
            {props.isFrom === PLP ? (
                renderStockLink(isEligibleForElement ? 'elementStock' : 'additionalFarnellStock')
            ) : (
                <FadeInOut show={true} duration={500} className={'visit-newark-box'}>
                    <div className='farnell-box p-3'>
                        <div className='bs5 row'>
                            <label className="d-flex align-items-center ms-1">{t('anotherBuyingOptionFromOurPartner')} <b> &nbsp;{isEligibleForElement ? t('element') : t('farnell')} <i className={'fa fa-exclamation-circle'} /></b></label>
                            {renderStockLink(isEligibleForElement ? 'elementStock' : 'additionalFarnellStock', isEligibleForElement ? element14logo : farnell)}
                        </div>
                    </div>
                </FadeInOut>
            )}
        </>
    );
};

export default AdditionalStock;
